module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan03_point-70e671d79b965ece30a8620272f0bd38.jpg";